import { useMutation } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import posthog from 'posthog-js'
import { createFullDiscountOrder } from 'services/plan'

/**
 * Activates the package straight away for a 100%-off code — there is no gateway
 * step because there is nothing to pay. See `createFullDiscountOrder` for why
 * this uses the v1 order path rather than the v2 gateway flow.
 */
export default function useFullDiscountOrder(moneyPool?: string) {
    const navigate = useNavigate()

    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: IFullDiscountOrderPayload) =>
            createFullDiscountOrder(payload),
        onSuccess: (_result, variables) => {
            posthog.capture('subscription_activated_with_full_discount', {
                month_count: variables?.monthCount,
            })
            toast.success('اشتراک صندوق با کد تخفیف فعال شد')
            navigate(`/fund/${moneyPool}`)
        },
        onError: (error: any) => {
            posthog.capture('subscription_purchase_failed', {
                status: error?.response?.status,
                flow: 'full_discount',
            })
            const data = error?.response?.data
            const detail =
                (typeof data?.error === 'string' && data.error) ||
                (typeof data?.detail === 'string' && data.detail) ||
                (Array.isArray(data?.non_field_errors) &&
                    data.non_field_errors[0])
            toast.error(detail || 'فعال‌سازی اشتراک ممکن نشد')
        },
    })

    return { mutate, isLoading }
}
